/**
 * Check if the browser is headless
 *
 * Do not use this hook on the server side as it will likely result
 * in hydration errors.
 */
export function isHeadlessBrowser() {
    return ((typeof window !== 'undefined' &&
        typeof window.navigator !== 'undefined' &&
        typeof window.navigator.webdriver !== 'undefined' &&
        window.navigator.webdriver) ||
        (typeof localStorage !== 'undefined' && localStorage.getItem('isPlaywright') === 'true'));
}
